import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  InputBase,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Box,
  Collapse,
  Menu,
  MenuItem,
  Tooltip,
  Divider,
  Paper,
  CircularProgress,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

/* ── Per-module icons ── */
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";

import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { fetchData } from "../BaseUrl";
import NotificationBell from "../DynamicComponent/NotificationBell";
import ErrorBoundary from "../DynamicComponent/ErrorBoundary";
import colors from "../Assest/Theme/Color";
import logoImg from "../Assest/Images/headerlogonew.svg";

/* ─── Constants ─────────────────────────────────────────── */
const DRAWER_OPEN_WIDTH = 250;
const DRAWER_CLOSED_WIDTH = 72;

/* Active state colours */
const ACTIVE_BG = "#EEF7E8";
const ACTIVE_COLOR = "#2E5F1E";
const ACTIVE_BORDER = "#4caf50";
const INACTIVE_COLOR = "#9CA3AF";
const HOVER_BG = "#F5F5F5";

/* ─── Menu definitions ──────────────────────────────────── */
const studentMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "Leave Management",
    icon: <TrendingUpOutlinedIcon />,
    path: "leave-management",
  },
  {
    text: "Google Classroom",
    icon: <MenuBookOutlinedIcon />,
    path: "google-classroom",
  },
  {
    text: "Academic Documents",
    icon: <ShieldOutlinedIcon />,
    path: "academic-documents",
  },
  { text: "Textbooks", icon: <AutoStoriesOutlinedIcon />, path: "textbooks" },
  {
    text: "Complaint Management",
    icon: <ReportProblemOutlinedIcon />,
    path: "complaint-management",
  },
  {
    text: "Classroom",
    icon: <PeopleAltOutlinedIcon />,
    path: "classroom-resources",
  },
  {
    text: "Withdrawal Enquiries",
    icon: <HowToRegOutlinedIcon />,
    path: "withdrawal-enquiries",
  },
  {
    text: "Progress Report",
    icon: <CalendarTodayOutlinedIcon />,
    path: "progress-report",
  },
  {
    text: "Project Guidelines",
    icon: <FlagOutlinedIcon />,
    path: "student-project-guidelines",
  },
  {
    text: "Pick-up/ Drop",
    icon: <DirectionsCarOutlinedIcon />,
    path: "pickup-drop",
  },
  {
    text: "Seal of Biliteracy",
    icon: <WorkspacePremiumOutlinedIcon />,
    path: "seal-of-biliteracy",
  },
  {
    text: "My Profile",
    icon: <AccountCircleOutlinedIcon />,
    path: "student-profile",
  },
];

const teacherMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "Student List",
    icon: <PeopleAltOutlinedIcon />,
    path: "teacher-student-list",
  },
  {
    text: "Attendance",
    icon: <CalendarTodayOutlinedIcon />,
    path: "teacher-attendance",
  },
  {
    text: "Progress Report",
    icon: <AssessmentOutlinedIcon />,
    path: "teacher-progress-report",
  },
  {
    text: "Billiteracy Evaluation",
    icon: <WorkspacePremiumOutlinedIcon />,
    path: "teacher-biliteracy",
  },
  {
    text: "Question Paper",
    icon: <QuizOutlinedIcon />,
    path: "teacher-question-paper",
  },
  {
    text: "Google Classroom",
    icon: <MenuBookOutlinedIcon />,
    path: "teacher-classroom",
  },
  {
    text: "Pickup & Drop",
    icon: <DirectionsCarOutlinedIcon />,
    path: "teacher-pickup-drop",
  },
  {
    text: "Document Placeholder",
    icon: <FolderOpenOutlinedIcon />,
    path: "teacher-documents",
  },
  {
    text: "Submission Review",
    icon: <AssignmentTurnedInOutlinedIcon />,
    path: "teacher-submissions",
  },
  {
    text: "Complaint Management",
    icon: <ReportProblemOutlinedIcon />,
    path: "teacher-complaints",
  },
  {
    text: "Leave Management",
    icon: <TrendingUpOutlinedIcon />,
    path: "teacher-leave",
  },
  {
    text: "Re-Imbursement",
    icon: <CurrencyExchangeOutlinedIcon />,
    path: "teacher-reimbursement",
  },
  {
    text: "Project Guidelines",
    icon: <FlagOutlinedIcon />,
    path: "teacher-project-guidelines",
  },
  { text: "My Profile", icon: <PersonOutlineIcon />, path: "teacher-profile" },
];

const parentMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "My Child's Profile",
    icon: <AccountCircleOutlinedIcon />,
    path: "parent-student-profile",
  },
  {
    text: "Progress Report",
    icon: <AssessmentOutlinedIcon />,
    path: "parent-progress-report",
  },
  {
    text: "Attendance",
    icon: <CalendarTodayOutlinedIcon />,
    path: "parent-attendance",
  },
  {
    text: "Complaint",
    icon: <ReportProblemOutlinedIcon />,
    path: "parent-complaint",
  },
  {
    text: "Withdrawal",
    icon: <HowToRegOutlinedIcon />,
    path: "parent-withdrawal",
  },
];

const staffMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "Check-In / Out",
    icon: <CheckCircleOutlineIcon />,
    path: "staff-checkinout",
  },
  {
    text: "Leave Calendar",
    icon: <DateRangeOutlinedIcon />,
    path: "staff-leave-calendar",
  },
  {
    text: "Leave Management",
    icon: <TrendingUpOutlinedIcon />,
    path: "staff-leave",
  },
  {
    text: "Mandatory Leave Form",
    icon: <AssignmentTurnedInOutlinedIcon />,
    path: "staff-mandate-leave",
  },
  {
    text: "Inventory",
    icon: <InventoryOutlinedIcon />,
    path: "staff-inventory",
  },
  {
    text: "Complaint",
    icon: <ReportProblemOutlinedIcon />,
    path: "staff-complaint",
  },
  {
    text: "Reimbursement",
    icon: <CurrencyExchangeOutlinedIcon />,
    path: "staff-reimbursement",
  },
  { text: "My Profile", icon: <PersonOutlineIcon />, path: "staff-profile" },
];

const principalMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "Student Registrations",
    icon: <SchoolOutlinedIcon />,
    path: "principal-registrations",
  },
  {
    text: "Withdrawal Approvals",
    icon: <HowToRegOutlinedIcon />,
    path: "principal-withdrawal",
  },
  {
    text: "Leave Approvals",
    icon: <AssignmentTurnedInOutlinedIcon />,
    path: "principal-leave",
  },
  {
    text: "Attendance Overview",
    icon: <CalendarTodayOutlinedIcon />,
    path: "attendance",
  },
];

const adminMenu = [
  { text: "Dashboard", icon: <GridViewOutlinedIcon />, path: "/dashboard" },
  {
    text: "Registration",
    icon: <AssignmentOutlinedIcon />,
    path: "registrations",
  },
  { text: "Admissions", icon: <SchoolOutlinedIcon />, path: "admissions" },
  { text: "Master", icon: <AdminPanelSettingsOutlinedIcon />, path: "master" },
  {
    text: "Volunteer",
    icon: <VolunteerActivismOutlinedIcon />,
    path: "volunteers",
  },
  {
    text: "Attendance",
    icon: <CalendarTodayOutlinedIcon />,
    path: "attendance",
  },
  { text: "Payment", icon: <PaymentOutlinedIcon />, path: "payment" },
  {
    text: "Complaint",
    icon: <ReportProblemOutlinedIcon />,
    path: "complaints",
  },
  {
    text: "Curriculum",
    icon: <MenuBookOutlinedIcon />,
    path: "curriculum-config",
  },
  { text: "Inventory", icon: <InventoryOutlinedIcon />, path: "inventory" },
  {
    text: "Role Configuration",
    icon: <AdminPanelSettingsOutlinedIcon />,
    path: "role-config",
  },
  { text: "Repository", icon: <FolderOpenOutlinedIcon />, path: "repository" },
  {
    text: "Classroom",
    icon: <MeetingRoomOutlinedIcon />,
    path: "classroom-management",
  },
  {
    text: "Project Guidelines",
    icon: <FlagOutlinedIcon />,
    path: "project-guidelines",
  },
  {
    text: "Withdrawal Mgmt",
    icon: <HowToRegOutlinedIcon />,
    path: "admin-withdrawal",
  },
  {
    text: "Form Access",
    icon: <AccessTimeOutlinedIcon />,
    path: "form-access-config",
  },
  {
    text: "Password Reset",
    icon: <LockResetOutlinedIcon />,
    path: "password-reset",
  },
  {
    text: "Website Config",
    icon: <SettingsOutlinedIcon />,
    path: "website-config",
  },
  { text: "Social Media", icon: <ShareOutlinedIcon />, path: "social-media" },
  {
    text: "VP Leave Portal",
    icon: <AdminPanelSettingsOutlinedIcon />,
    path: "vp-leave-portal",
  },
  {
    text: "Biliteracy Mgmt",
    icon: <WorkspacePremiumOutlinedIcon />,
    path: "admin-biliteracy",
  },
  {
    text: "Calendar Config",
    icon: <EventNoteOutlinedIcon />,
    path: "calendar-config",
  },
  {
    text: "Events Config",
    icon: <EmojiEventsOutlinedIcon />,
    path: "event-config",
  },
  {
    text: "Contact Us Config",
    icon: <ContactMailOutlinedIcon />,
    path: "contact-us-config",
  },
  {
    text: "Seal Config",
    icon: <WorkspacePremiumOutlinedIcon />,
    path: "seal-biliteracy-config",
  },
  {
    text: "Flipbook Docs",
    icon: <LibraryBooksOutlinedIcon />,
    path: "admin-flipbook",
  },
  {
    text: "Staff Attendance",
    icon: <CheckCircleOutlineIcon />,
    path: "staff-attendance",
  },
  {
    text: "Question Papers",
    icon: <QuizOutlinedIcon />,
    path: "admin-question-paper",
  },
  {
    text: "Textbooks",
    icon: <AutoStoriesOutlinedIcon />,
    path: "admin-textbooks",
  },
  {
    text: "Google Classroom",
    icon: <MenuBookOutlinedIcon />,
    path: "admin-google-classroom",
  },
];

/* ─── RBAC: menu text → AdminRoleConfig module name mapping ─── */
const MENU_MODULE_MAP = {
  Admissions: "Admission Module",
  "Progress Report": "Progress Reports",
  Attendance: "Attendance",
  "Student List": "Student List",
  "Billiteracy Evaluation": "Biliteracy Evaluation",
  "Question Paper": "Question Paper",
  "Google Classroom": "Google Classroom",
  "Document Placeholder": "Document Storage",
  "Leave Management": "Leave Management",
  "Pickup & Drop": "Pickup/Drop",
  "Complaint Management": "Complaint Management",
  "Submission Review": "Admission Module",
};

/* ─── Component ─────────────────────────────────────────── */
const DashboardLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [selectedItem, setSelectedItem] = useState("Dashboard");
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [roleMenu, setRoleMenu] = useState([]);
  const [rolePerms, setRolePerms] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef(null);
  const searchTimerRef = useRef(null);

  const drawerWidth = drawerOpen ? DRAWER_OPEN_WIDTH : DRAWER_CLOSED_WIDTH;
  const navigate = useNavigate();
  const location = useLocation();
  const value = sessionStorage.getItem("role");
  const isAdmin = !value || value === "/admin" || value === "/principal";

  const getFullPath = (menuPath) => {
    if (!menuPath) return "";
    if (menuPath.startsWith("/")) return menuPath;
    return `/dashboard/${menuPath}`;
  };

  const isMenuPathActive = (menuItem) => {
    if (menuItem.submenus) {
      return menuItem.submenus.some((sub) => isMenuPathActive(sub));
    }
    const currentPath = location.pathname.replace(/\/$/, "");
    const targetPath = getFullPath(menuItem.path).replace(/\/$/, "");

    if (targetPath === "/dashboard") {
      return currentPath === "/dashboard";
    }

    return (
      currentPath === targetPath || currentPath.startsWith(targetPath + "/")
    );
  };

  useEffect(() => {
    // Auto-expand submenus if current path is in one of them
    const hasActiveSubmenu = roleMenu.some(
      (menu) =>
        menu.submenus &&
        menu.submenus.some((sub) => {
          const currentPath = location.pathname.replace(/\/$/, "");
          const targetPath = getFullPath(sub.path).replace(/\/$/, "");
          return (
            currentPath === targetPath ||
            currentPath.startsWith(targetPath + "/")
          );
        }),
    );
    if (hasActiveSubmenu) {
      setOpenSubMenu(true);
    }
  }, [location.pathname, roleMenu]);

  useEffect(() => {
    if (value === "/student") setRoleMenu(studentMenu);
    else if (value === "/teacher") setRoleMenu(teacherMenu);
    else if (value === "/parent") setRoleMenu(parentMenu);
    else if (value === "/staff") setRoleMenu(staffMenu);
    else if (value === "/principal") setRoleMenu(principalMenu);
    else setRoleMenu(adminMenu);

    // RBAC §26: fetch role-level permissions for controlled roles
    const ROLE_KEY_MAP = {
      "/teacher": "Teacher",
      "/staff": "Para Professional",
    };
    const roleKey = ROLE_KEY_MAP[value];
    if (roleKey) {
      fetchData(
        `admin/role-config/roles/${encodeURIComponent(roleKey)}/permissions`,
      )
        .then((res) => {
          if (res?.data?.permissions) setRolePerms(res.data.permissions);
        })
        .catch(() => {}); // Silently fall through — show full menu if API unavailable
    }
  }, [value]);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleDrawerCollapse = () => setDrawerOpen(!drawerOpen);
  const handleMenuItemClick = (path) => navigate(path);
  const handleAvatarClick = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  /* ── Global search ── */
  const handleSearchChange = useCallback((e) => {
    const q = e.target.value;
    setSearchQuery(q);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    if (!q.trim() || q.trim().length < 2) {
      setSearchResults(null);
      setSearchOpen(false);
      return;
    }
    searchTimerRef.current = setTimeout(async () => {
      try {
        setSearchLoading(true);
        const data = await fetchData(
          `admin/search?q=${encodeURIComponent(q.trim())}&limit=5`,
        );
        setSearchResults(data?.data || data || {});
        setSearchOpen(true);
      } catch {
        setSearchResults(null);
      } finally {
        setSearchLoading(false);
      }
    }, 350);
  }, []);

  const handleSearchResultClick = (path) => {
    setSearchOpen(false);
    setSearchQuery("");
    setSearchResults(null);
    navigate(path);
  };

  const handleLogout = async () => {
    handleMenuClose();
    try {
      await fetchData("auth/logout");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  /* ── Sidebar item renderer ── */
  const SidebarItem = ({ menu, isSubItem = false }) => {
    const isActive = isMenuPathActive(menu);
    return (
      <Tooltip title={!drawerOpen ? menu.text : ""} placement="right" arrow>
        <ListItem
          button
          onClick={() => {
            if (menu.submenus) {
              setOpenSubMenu(!openSubMenu);
            } else {
              setSelectedItem(menu.text);
              handleMenuItemClick(menu.path || "/");
            }
          }}
          sx={{
            cursor: "pointer",
            borderRadius: "10px",
            mx: drawerOpen ? 1.5 : 0.5,
            my: 0.3,
            px: drawerOpen ? 1.5 : 1,
            py: 0.9,
            position: "relative",
            backgroundColor: isActive ? ACTIVE_BG : "transparent",
            borderLeft: isActive
              ? `3px solid ${ACTIVE_BORDER}`
              : "3px solid transparent",
            "&:hover": {
              backgroundColor: isActive ? ACTIVE_BG : HOVER_BG,
            },
            transition: "all 0.15s ease",
          }}
        >
          <ListItemIcon
            sx={{
              color: isActive ? ACTIVE_COLOR : INACTIVE_COLOR,
              minWidth: drawerOpen ? 36 : "auto",
              justifyContent: "center",
            }}
          >
            {React.cloneElement(menu.icon, { sx: { fontSize: "20px" } })}
          </ListItemIcon>

          {drawerOpen && (
            <ListItemText
              primary={menu.text}
              primaryTypographyProps={{
                fontSize: "13.5px",
                fontWeight: isActive ? 700 : 400,
                color: isActive ? ACTIVE_COLOR : INACTIVE_COLOR,
                fontFamily: "'Inter', 'Roboto', sans-serif",
                lineHeight: 1.4,
              }}
            />
          )}

          {menu.submenus && drawerOpen && (
            <ListItemIcon
              sx={{ ml: "auto", minWidth: "auto", color: INACTIVE_COLOR }}
            >
              {openSubMenu ? (
                <KeyboardArrowUpOutlinedIcon sx={{ fontSize: "18px" }} />
              ) : (
                <KeyboardArrowDownOutlinedIcon sx={{ fontSize: "18px" }} />
              )}
            </ListItemIcon>
          )}
        </ListItem>
      </Tooltip>
    );
  };

  /* ── RBAC-filtered menu ── */
  const displayMenu =
    Object.keys(rolePerms).length > 0
      ? roleMenu.filter((item) => {
          if (!item.text || item.text === "Dashboard") return true;
          const moduleName = MENU_MODULE_MAP[item.text];
          if (!moduleName) return true; // Not a controlled module — always show
          return rolePerms[moduleName]?.View !== false;
        })
      : roleMenu;

  /* ── Drawer content ── */
  const drawer = (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        borderRight: "1px solid #F3F4F6",
      }}
    >
      {/* ── Logo ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: drawerOpen ? 2.5 : 1.5,
          py: 2,
          minHeight: 72,
          borderBottom: "1px solid #F3F4F6",
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={logoImg}
          alt="CTS Logo"
          sx={{
            width: 40,
            height: 40,
            borderRadius: "8px",
            objectFit: "contain",
            flexShrink: 0,
            border: "1px solid #E5E7EB",
            p: "3px",
          }}
        />
        {drawerOpen && (
          <Box sx={{ ml: 1.5, lineHeight: 1 }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "14px",
                color: "#111827",
                lineHeight: 1.2,
              }}
            >
              Cumming
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "13px",
                color: "#374151",
                lineHeight: 1.2,
              }}
            >
              Tamil School
            </Typography>
          </Box>
        )}
      </Box>

      {/* ── Menu items ── */}
      <List sx={{ pt: 1.5, pb: 1, flexGrow: 1 }}>
        {displayMenu.map((menu) => (
          <React.Fragment key={menu.text}>
            <SidebarItem menu={menu} />
            {menu.submenus && (
              <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  sx={{ pl: drawerOpen ? 2 : 0 }}
                >
                  {menu.submenus.map((submenu) => (
                    <SidebarItem key={submenu.text} menu={submenu} isSubItem />
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
      </List>

      {/* ── Log Out ── */}
      <Box sx={{ px: 0, pb: 2, flexShrink: 0 }}>
        <Divider sx={{ mb: 1, borderColor: "#F3F4F6" }} />
        <Tooltip title={!drawerOpen ? "Log Out" : ""} placement="right" arrow>
          <ListItem
            button
            onClick={handleLogout}
            sx={{
              cursor: "pointer",
              borderRadius: "10px",
              mx: drawerOpen ? 1.5 : 0.5,
              px: drawerOpen ? 1.5 : 1,
              py: 0.9,
              "&:hover": { backgroundColor: "#FFF0F0" },
              transition: "all 0.15s ease",
            }}
          >
            <ListItemIcon
              sx={{
                color: "#9CA3AF",
                minWidth: drawerOpen ? 36 : "auto",
                justifyContent: "center",
              }}
            >
              <LogoutIcon sx={{ fontSize: "20px" }} />
            </ListItemIcon>
            {drawerOpen && (
              <ListItemText
                primary="Log Out"
                primaryTypographyProps={{
                  fontSize: "13.5px",
                  fontWeight: 500,
                  color: "#6B7280",
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                }}
              />
            )}
          </ListItem>
        </Tooltip>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* ── Desktop drawer ── */}
      <Box sx={{ position: "relative" }}>
        <Drawer
          variant="permanent"
          open={drawerOpen}
          sx={{
            display: { xs: "none", sm: "block" },
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              transition: "width 0.25s",
              boxSizing: "border-box",
              overflowX: "hidden",
              borderRight: "none",
              boxShadow: "2px 0 8px rgba(0,0,0,0.06)",
            },
          }}
        >
          {drawer}
        </Drawer>

        {/* Collapse toggle button */}
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <IconButton
            onClick={handleDrawerCollapse}
            sx={{
              background: "linear-gradient(45deg, #4A7BA8 30%, #244C77 90%)",
              color: "#fff",
              zIndex: 9999,
              position: "fixed",
              p: 0,
              left: drawerOpen
                ? DRAWER_OPEN_WIDTH - 20
                : DRAWER_CLOSED_WIDTH - 20,
              top: 35,
              "&:hover": {
                background: "linear-gradient(45deg, #4A7BA8 30%, #244C77 90%)",
              },
            }}
          >
            {drawerOpen ? (
              <ChevronLeftIcon fontSize="large" />
            ) : (
              <ChevronRightIcon fontSize="large" />
            )}
          </IconButton>
        </Box>
      </Box>

      {/* ── Mobile drawer ── */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          width: DRAWER_OPEN_WIDTH,
          "& .MuiDrawer-paper": {
            width: DRAWER_OPEN_WIDTH,
            transition: "width 0.25s",
            boxSizing: "border-box",
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* ── Main content ── */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: `calc(100% - ${drawerWidth}px)`,
        }}
      >
        {/* ── Top navbar ── */}
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            backgroundColor: colors.bgColor,
            width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" },
            ml: { sm: `${drawerWidth}px`, xs: "0" },
            boxShadow: "none",
            border: "none",
            transition: "width 0.25s, margin-left 0.25s",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>

            <Box
              ml="auto"
              px={3}
              sx={{ flexGrow: 1, position: "relative" }}
              ref={searchRef}
            >
              {isAdmin && (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E0E0E0",
                      borderRadius: "15px",
                      padding: "2px 10px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                      "&:hover": { borderColor: "#D0D0D0" },
                    }}
                  >
                    <IconButton sx={{ p: 0 }}>
                      {searchLoading ? (
                        <CircularProgress size={18} sx={{ color: "#B0B0B0" }} />
                      ) : (
                        <SearchIcon sx={{ color: "#B0B0B0" }} />
                      )}
                    </IconButton>
                    <InputBase
                      placeholder="Search students, applications, complaints…"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      onBlur={() => setTimeout(() => setSearchOpen(false), 200)}
                      onFocus={() => searchResults && setSearchOpen(true)}
                      sx={{
                        ml: 2,
                        flex: 1,
                        fontSize: "14px",
                        color: "#333333",
                        padding: "5px",
                      }}
                    />
                  </Box>

                  {searchOpen && searchResults && (
                    <Paper
                      elevation={4}
                      sx={{
                        position: "absolute",
                        top: "calc(100% + 6px)",
                        left: 24,
                        right: 0,
                        zIndex: 9999,
                        borderRadius: "10px",
                        maxHeight: 360,
                        overflowY: "auto",
                        py: 1,
                      }}
                    >
                      {[
                        {
                          key: "students",
                          label: "Students",
                          pathFn: (r) => `/dashboard/admissions`,
                        },
                        {
                          key: "applications",
                          label: "Applications",
                          pathFn: (r) => `/dashboard/registrations`,
                        },
                        {
                          key: "complaints",
                          label: "Complaints",
                          pathFn: (r) => `/dashboard/complaints`,
                        },
                        {
                          key: "withdrawals",
                          label: "Withdrawals",
                          pathFn: (r) => `/dashboard/admin-withdrawal`,
                        },
                      ].map(({ key, label, pathFn }) => {
                        const items = searchResults[key] || [];
                        if (!items.length) return null;
                        return (
                          <Box key={key}>
                            <Typography
                              sx={{
                                px: 2,
                                py: 0.5,
                                fontSize: "11px",
                                fontWeight: 700,
                                color: "#9CA3AF",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {label}
                            </Typography>
                            {items.map((item, i) => (
                              <MenuItem
                                key={i}
                                onClick={() =>
                                  handleSearchResultClick(pathFn(item))
                                }
                                sx={{
                                  fontSize: "13px",
                                  px: 2,
                                  py: 0.75,
                                  color: "#374151",
                                  "&:hover": { backgroundColor: "#F3F4F6" },
                                }}
                              >
                                {item.studentName ||
                                  item.name ||
                                  item.fullName ||
                                  item.complainantName ||
                                  item.subject ||
                                  `${item.firstName || ""} ${item.lastName || ""}`.trim() ||
                                  item.registrationNo ||
                                  `#${item.id}`}
                                {item.registrationNo && (
                                  <Typography
                                    component="span"
                                    sx={{
                                      ml: 1,
                                      fontSize: "11px",
                                      color: "#9CA3AF",
                                    }}
                                  >
                                    {item.registrationNo}
                                  </Typography>
                                )}
                              </MenuItem>
                            ))}
                          </Box>
                        );
                      })}
                      {Object.values(searchResults).every(
                        (arr) => !arr?.length,
                      ) && (
                        <Typography
                          sx={{
                            px: 2,
                            py: 1.5,
                            fontSize: "13px",
                            color: "#9CA3AF",
                            textAlign: "center",
                          }}
                        >
                          No results found
                        </Typography>
                      )}
                    </Paper>
                  )}
                </>
              )}
            </Box>

            <NotificationBell />
            <IconButton>
              <SettingsOutlinedIcon />
            </IconButton>

            <Avatar
              sx={{
                bgcolor: "gray",
                ml: 2,
                cursor: "pointer",
                width: 36,
                height: 36,
              }}
              onClick={handleAvatarClick}
              src={sessionStorage.getItem("profilePic") || undefined}
            >
              {(sessionStorage.getItem("userFullName") || "U")[0].toUpperCase()}
            </Avatar>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{ sx: { borderRadius: "10px", mt: 0.5 } }}
            >
              <MenuItem onClick={handleMenuClose} sx={{ fontSize: "13px" }}>
                {sessionStorage.getItem("userFullName") || "User"}
              </MenuItem>
              <MenuItem
                onClick={handleLogout}
                sx={{ fontSize: "13px", color: "#f44336" }}
              >
                Logout
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>

        {/* Page content */}
        <Box sx={{ flexGrow: 1, backgroundColor: colors.bgColor, p: 2, mt: 8 }}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
